import { createFormContext } from "@mantine/form";
import { createContext } from "react";

export const getName = (questionNumberFromZero) => {
    return "Q" + (questionNumberFromZero + 1);
};

const TIME_DIVISIONS = [
    { amount: 60, name: "seconds", sname: "secs" },
    { amount: 60, name: "minutes", sname: "mins" },
    { amount: 24, name: "hours", sname: "hrs" },
    { amount: 7, name: "days", sname: "days" },
    { amount: 4.34524, name: "weeks", sname: "wks" },
    { amount: 12, name: "months", sname: "mth" },
    { amount: Number.POSITIVE_INFINITY, name: "years", sname: "yrs" },
];

export const formatDateAgo = (timestamp) => {
    let formatter = new Intl.RelativeTimeFormat(undefined, {
        numeric: "auto",
    });
    let duration = (timestamp - Date.now()) / 1000;
    for (let idx = 0; idx < TIME_DIVISIONS.length; idx++) {
        const division = TIME_DIVISIONS[idx];
        if (Math.abs(duration) < division.amount) {
            return formatter.format(Math.round(duration), division.name);
        }
        duration /= division.amount;
    }
};
export const formatTimeTaken = (timestamp) => {
    let duration = timestamp / 1000;
    for (let idx = 0; idx < TIME_DIVISIONS.length; idx++) {
        const division = TIME_DIVISIONS[idx];
        if (Math.abs(duration) < division.amount) {
            return Math.round(duration) + " " + division.name;
        }
        duration /= division.amount;
    }
};

export const formatDurationTime = (secs) => {
    let duration = secs;
    for (let idx = 0; idx < TIME_DIVISIONS.length; idx++) {
        const division = TIME_DIVISIONS[idx];
        if (Math.abs(duration) < division.amount) {
            return duration + " " + division.sname;
        }
        duration /= division.amount;
    }
};

const analytics_to_line_chart_data = ({ analytics }) => {
    const test_data = analytics.map(
        ({
            id: analyticsid,
            current_test: {
                id,
                title,
                testrules: { totalMarks },
            },
            scorecard: { marks_obtained },
        }) => {
            // const formatted_date = new Date(test_start_ts)
            //     .toISOString()
            //     .split("T")[0]; // 2022-12-20
            const marks_percent = ((marks_obtained / totalMarks) * 100).toFixed(
                2
            );
            return {
                x: title,
                y: marks_percent,
                testid: id,
                analyticsid,
            };
        }
    );
    return test_data;
};

export const getLineChartData = ({ all_analytics, current_user_id }) => {
    const lineChartData = [];

    // user data
    // first find the maximum marks got in each tests(from multiple attempts)
    const current_analytics = all_analytics.filter(
        (x) => x.user_info.user_id == current_user_id
    );
    let user_analytics = current_analytics.sort(
        (a, b) => b.scorecard.marks_obtained - a.scorecard.marks_obtained
    );
    // choose only first occurring testids
    let user_test_set = new Set();

    user_analytics = user_analytics.filter(
        ({ current_test: { id: testid } }) => {
            if (!user_test_set.has(testid)) {
                user_test_set.add(testid);
                return true;
            }
            return false;
        }
    );

    let test_order = []; // ordering by the time of attempt of test
    user_analytics = user_analytics.sort(
        (a, b) => a.current_test.test_start_ts - b.current_test.test_start_ts
    );
    user_analytics.forEach(({ current_test: { id: testid } }) => {
        test_order.push(testid);
    });

    const user_data = {
        id: "You",
        data: analytics_to_line_chart_data({ analytics: user_analytics }),
    };
    // console.log(user_data);

    // get the topper analytics
    // the highest marks obtained in each tests
    let topper_analytics = all_analytics.sort(
        (a, b) => b.scorecard.marks_obtained - a.scorecard.marks_obtained
    );

    let topper_test_set = new Set();
    topper_analytics = topper_analytics.filter(
        ({ current_test: { id: testid } }) => {
            let include = false;
            if (!topper_test_set.has(testid) && user_test_set.has(testid)) {
                include = true;
            }
            topper_test_set.add(testid);
            return include;
        }
    );
    topper_analytics = topper_analytics.sort(
        (a, b) =>
            test_order.indexOf(a.current_test.id) -
            test_order.indexOf(b.current_test.id)
    );
    const topper_data = {
        id: "Topper",
        data: analytics_to_line_chart_data({ analytics: topper_analytics }),
    };
    // console.log(topper_data);

    let average_data = {
        id: "Average",
        data: [],
    };
    for (let idx = 0; idx < test_order.length; idx++) {
        const cur_testid = test_order[idx];
        let test_title = "";
        let marks_sum = 0;
        let total_count = 0;
        let total_marks = 0;
        all_analytics
            .filter(({ current_test: { id: testid } }) => testid == cur_testid)
            .map(
                ({
                    scorecard: { marks_obtained },
                    current_test: {
                        title,
                        testrules: { totalMarks },
                    },
                }) => ({ marks_obtained, title, totalMarks })
            )
            .forEach(({ marks_obtained, title, totalMarks }) => {
                test_title = title;
                total_marks = totalMarks;
                marks_sum += marks_obtained;
                total_count += 1;
            });
        let marks_cent =
            total_count == 0
                ? 0
                : (100 * (marks_sum / (total_count * total_marks))).toFixed(2);
        average_data.data.push({
            x: test_title,
            y: marks_cent,
        });
    }

    // console.log("average_data", average_data);
    // sort the data coz there was error in the analytics chart
    // console.log(average_data.data[0].x);
    const order = user_data.data.map((x) => x.x);

    average_data.data.sort((a, b) => order.indexOf(a.x) - order.indexOf(b.x));
    topper_data.data.sort((a, b) => order.indexOf(a.x) - order.indexOf(b.x));

    // average_data.data.sort((a, b) => a.x.localeCompare(b.x));
    // user_data.data.sort((a, b) => a.x.localeCompare(b.x));
    // topper_data.data.sort((a, b) => a.x.localeCompare(b.x));

    return [average_data, user_data, topper_data];
};

export const compute_ASM_data = ({
    func,
    all_analytics,
    current_user_id,
    testid = null,
}) => {
    const data = func({ all_analytics, current_user_id, testid });
    const { current_user_value, all_user_value_aggregate } = extract_data_value(
        data,
        current_user_id
    );
    let all_user_value_avg = all_user_value_aggregate / data.length;
    return { current_user_value, all_user_value_avg };
};

export const getOverallSpeedData = ({
    all_analytics,
    current_user_id,
    testid = null,
}) => {
    let test_order = !!testid
        ? [testid]
        : get_test_order({ all_analytics, current_user_id });
    let user_list = get_user_list({ all_analytics, test_order });
    let all_user_speed = user_list.map((user_id) => {
        return get_user_speed({ user_id, all_analytics, test_order });
    });
    return all_user_speed;
};

const get_user_speed = ({ user_id, all_analytics, test_order }) => {
    let user_analytics = get_user_test_analytics({
        user_id,
        all_analytics,
        test_order,
    });

    let sum_avg_speed_per_test = 0;
    let sum_num_test = 0;

    console.log("user_analytics.length", user_analytics.length);
    user_analytics.forEach(({ questions }) => {
        let sum_time = 0;
        let num_questions = 0;
        Object.keys(questions).forEach((qno) => {
            const { start_ts, end_ts, selected } = questions[qno];
            if (!!selected) {
                sum_time += end_ts - start_ts;
                num_questions += 1;
            }
        });
        console.log(sum_time, num_questions);
        if (num_questions > 0) {
            // num_questions == 0 if all questions are unanswered
            sum_avg_speed_per_test += sum_time / num_questions;
            sum_num_test += 1;
        }
        // console.log(questions.length);
    });

    let avg_speed = sum_avg_speed_per_test / sum_num_test;
    if (sum_num_test == 0) avg_speed = 0;

    return { user_id, value: avg_speed };
};

export const getOverallAccuracyData = ({
    all_analytics,
    current_user_id,
    testid = null,
}) => {
    // get the test order given by current_user_id user, in ascending order of exam start time
    let test_order = !!testid
        ? [testid]
        : get_test_order({ all_analytics, current_user_id });
    let user_list = get_user_list({ all_analytics, test_order });

    let all_user_accuracy = user_list.map((user_id) => {
        return get_user_accuracy({ user_id, all_analytics, test_order });
    });

    return all_user_accuracy;
};
const get_user_accuracy = ({ user_id, all_analytics, test_order }) => {
    // get this user data
    let user_analytics = get_user_test_analytics({
        user_id,
        all_analytics,
        test_order,
    });

    let sum_num_correct_question = 0;
    let sum_num_negative_question = 0;

    user_analytics.forEach(
        ({ scorecard: { num_correct_question, num_negative_question } }) => {
            sum_num_correct_question += num_correct_question;
            sum_num_negative_question += num_negative_question;
        }
    );

    let avg_accuracy =
        100 *
        (sum_num_correct_question /
            (sum_num_correct_question + sum_num_negative_question));

    if (sum_num_correct_question + sum_num_negative_question == 0)
        avg_accuracy = 0;
    return { user_id, value: avg_accuracy };
};

const get_user_test_analytics = ({
    user_id,
    all_analytics,
    test_order = null,
}) => {
    // get this user data
    let user_analytics = all_analytics.filter(
        (x) => x.user_info.user_id == user_id
    );
    user_analytics = user_analytics.sort(
        (a, b) => a.scorecard.marks_obtained - b.scorecard.marks_obtained
    );

    let user_test_set = new Set();
    user_analytics = user_analytics.filter(
        ({ current_test: { id: testid } }) => {
            if (
                !user_test_set.has(testid) &&
                (!!!test_order || (!!test_order && test_order.includes(testid)))
            ) {
                user_test_set.add(testid);
                return true;
            }
            return false;
        }
    );

    return user_analytics;
};

const get_user_list = ({ all_analytics, test_order = null }) => {
    // get all user list who has given the tests in the test_order array
    // get marks for each user for the above tests
    const all_test_order_analytics = all_analytics.filter(
        ({ current_test: { id: testid } }) =>
            !!!test_order || test_order.includes(testid)
    );

    // get all user list
    let user_list_set = new Set();
    all_test_order_analytics.forEach(({ user_info: { user_id } }) => {
        user_list_set.add(user_id);
    });
    return Array.from(user_list_set);
};

const get_test_order = ({ all_analytics, current_user_id }) => {
    const current_analytics = all_analytics.filter(
        (x) => x.user_info.user_id == current_user_id
    );
    let user_analytics = current_analytics.sort(
        (a, b) => a.current_test.test_start_ts - b.current_test.test_start_ts
    );
    let user_test_set = new Set();
    let test_order = [];

    user_analytics.forEach(({ current_test: { id: testid } }) => {
        if (!user_test_set.has(testid)) {
            user_test_set.add(testid);
            test_order.push(testid);
        }
    });
    return test_order;
};

export const getOverallMarksData = ({
    all_analytics,
    current_user_id,
    testid = null, // for loading single test data
}) => {
    let test_order = !!testid
        ? [testid]
        : get_test_order({ all_analytics, current_user_id });

    console.log("test_order", testid);
    let user_list = get_user_list({ all_analytics, test_order });

    console.log("test_order", test_order);
    console.log("user_list", user_list);
    // get overall marks for each user
    let all_user_marks = user_list.map((user_id) => {
        return get_user_marks({ user_id, all_analytics, test_order });
    });
    all_user_marks.sort((a, b) => parseFloat(b.value) - parseFloat(a.value));

    return all_user_marks;
};

export const getOverallScoreData = ({
    all_analytics,
    // current_user_id,
    // testid = null, // for loading single test data
}) => {
    // let test_order = !!testid
    //     ? [testid]
    //     : get_test_order({ all_analytics, current_user_id });

    // console.log("test_order", testid);
    let user_list = get_user_list({ all_analytics, test_order: null });

    // console.log("test_order", test_order);
    // console.log("user_list", user_list);
    // get overall marks for each user
    let all_user_marks = user_list.map((user_id) => {
        return get_user_score({ user_id, all_analytics });
    });
    all_user_marks.sort((a, b) => parseFloat(b.value) - parseFloat(a.value));

    return all_user_marks;
};

const get_user_score = ({ user_id, all_analytics }) => {
    // get this user data
    let user_analytics = get_user_test_analytics({
        user_id,
        all_analytics,
    });

    // get average marks in each test
    let marks_obtained_sum = 0;
    let total_marks_sum = 0;

    let score_obtained_sum = 0;
    user_analytics.forEach(
        ({
            current_test: {
                testrules: { totalMarks },
            },
            scorecard: { marks_obtained },
        }) => {
            marks_obtained_sum += marks_obtained;
            total_marks_sum += totalMarks;

            score_obtained_sum += 100 * parseFloat(marks_obtained / totalMarks);
        }
    );

    return { user_id, value: score_obtained_sum };
};

const get_user_marks = ({ user_id, all_analytics, test_order }) => {
    // get this user data
    let user_analytics = get_user_test_analytics({
        user_id,
        all_analytics,
        test_order,
    });

    // get average marks in each test
    let marks_obtained_sum = 0;
    let total_marks_sum = 0;

    user_analytics.forEach(
        ({
            current_test: {
                testrules: { totalMarks },
            },
            scorecard: { marks_obtained },
        }) => {
            marks_obtained_sum += marks_obtained;
            total_marks_sum += totalMarks;
        }
    );

    let avg_marks = 0;
    if (total_marks_sum != 0)
        avg_marks = (100 * (marks_obtained_sum / total_marks_sum)).toFixed(2);

    return { user_id, value: avg_marks };
};

export const extract_data_value = (data, current_user_id) => {
    // const { user_id, value } = data;
    let all_user_value_aggregate = 0;
    let current_user_value = 0;

    for (let idx = 0; idx < data.length; idx++) {
        const { user_id, value } = data[idx];
        if (user_id == current_user_id)
            current_user_value = parseFloat(value).toFixed(1);
        all_user_value_aggregate += parseFloat(value);
    }

    return { current_user_value, all_user_value_aggregate };
};

export const dataHeatMapCalendarChart = ({ current_analytics }) => {
    const dates = current_analytics.map(
        ({ current_test: { test_start_ts } }) => {
            return new Date(test_start_ts).toISOString().split("T")[0];
        }
    );
    const counts = {};
    dates.forEach((date) => {
        counts[date] = 1 + (!!counts[date] ? counts[date] : 0);
    });
    const data = Object.keys(counts).map((date) => {
        return {
            value: counts[date],
            day: date,
        };
    });
    return data;
};

export const dataSingleTestAnalyticsLineChart = ({ current_analytics }) => {
    const speed_data = Object.keys(current_analytics.questions).map(
        (qno, idx) => {
            let q_name = qno;
            const { end_ts, start_ts, selected } =
                current_analytics.questions[qno];
            let time_took = (end_ts - start_ts) / 1000;
            if (!!selected)
                return {
                    x: q_name,
                    y: time_took,
                };
            else
                return {
                    x: q_name,
                    y: 0,
                };
        }
    );

    const data = [
        {
            id: "Your Speed",
            data: speed_data,
        },
    ];
    // [{
    //     id: "Your Speed",
    //     data: [
    //         { x: "Q1", y: 10 },
    //         { x: "Q2", y: 30 },
    //         { x: "Q3", y: 80 },
    //         { x: "Q4", y: 80 },
    //     ],
    // },]
    return data;
};

export const testpaperui_reducer = (state, action) => {
    console.log("DISPATCHING : ", action.type);
    // reducer to manage the state of analytics
    if (action.type == "increment") {
        console.log({ action });
        return {
            ...state,
            age: state.age + 1,
        };
    }

    if (action.type == "SET_TEXT") {
        console.log({ action });
        return {
            ...state,
            text: action.payload,
        };
    }

    if (action.type == "QUESTION_START_TS") {
        console.log({ action });
        const { name } = action.payload;
        const start_ts = Date.now();
        // update the existing question start_ts
        // only if it is not defined previously
        const newquestion = {
            start_ts,
            ...state.questions[name],
        };

        // override the existing question with name (Q1, Q2 ...)
        const newquestions_list = {
            ...state.questions,
            name: newquestion,
        };
        return {
            ...state,
            questions: { ...newquestions_list },
        };
    }
    if (action.type == "QUESTION_END_TS") {
        console.log({ action });
        const { name } = action.payload;
        const end_ts = Date.now();
        // update the existing question's end_ts
        const newquestion = {
            ...state.questions[name],
            end_ts,
        };

        // override the existing question with name (Q1, Q2 ...)
        const newquestions_list = {
            ...state.questions,
            name: newquestion,
        };
        return {
            ...state,
            questions: { ...newquestions_list },
        };
    }
    if (action.type == "SET_STATE") {
        console.log({ action });
        const initialstate = action.payload;

        return {
            ...initialstate,
        };
    }

    if (action.type == "UPDATE_QUESTION_SELECTION") {
        console.log({ action });
        const { name, selected } = action.payload;
        // update the existing question selected
        const newquestion = {
            ...state.questions[name],
            selected,
        };

        // override the existing questions with name (Q1, Q2 ...)
        const newquestions_list = {
            ...state.questions,
            name: newquestion,
        };
        return {
            ...state,
            questions: { ...newquestions_list },
        };
    }
    throw Error("Unknown action.");
};

export const TestPaperUI2Dispatch = createContext(null);
